import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProgramRole } from '@app/shared/enums/program-role.enum';
import { UserListApiModel } from '@app/api/api-models/users/UserListApiModel';
import { ProgramUserListApiModel } from '@app/api/api-models/users/program-users-list/ProgramUserListApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class ProgramUsersService {
  public apiUrl = 'program-users';

  constructor(private readonly http: HttpClientService) {}

  public getAvailableUsersList(): Observable<UserListApiModel[]> {
    return this.http.get<UserListApiModel[]>(`${this.apiUrl}/available-users`);
  }

  public getList(role: ProgramRole, isForMultiple = false): Observable<ProgramUserListApiModel[]> {
    return this.http
      .get<ProgramUserListApiModel[]>(`${this.apiUrl}/get-list/${role}/${isForMultiple}`)
      .pipe(map((array) => array.map((x) => new ProgramUserListApiModel().deserialize(x))));
  }

  public removeUser(programRoleId: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/delete/${programRoleId}`);
  }
}
